import request from '@/utils/request'

/**
 * facebook上报open事件
 * @param {*} data
 * @returns
 */
export function openEventReport(data, headers) {
    return request({
        url: '4d680f84f0b0ba7949',
        method: 'post',
        data,
        headers,
    })
}